// extracted by mini-css-extract-plugin
export default {"header":"Header_header__DAtc8","icons":"Header_icons__x4xbS","borderRight":"Header_borderRight__CirPr","notification":"Header_notification__6hN6X"};